module.exports = __webpack_public_path__ + "img/favor_select.4bfc1cea.png";